const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // web-vitals v3+ renamed the get*() metric functions to on*() and
    // replaced getFID with onINP (First Input Delay was deprecated in
    // favor of Interaction to Next Paint). See:
    // https://github.com/GoogleChrome/web-vitals/blob/main/CHANGELOG.md
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
